<script lang="ts" setup>
import { useShutdownApp } from '@composables/useShutDownApp'
import BrandIcon from './icons/BrandIcon.vue'

const { handleHeaderClick } = useShutdownApp()
</script>

<template>
  <header data-test="header" class="flex h-[calc(192*var(--vh))] w-full justify-center">
    <div class="mb-vh-24 gap-vw-96 mt-auto items-center">
      <BrandIcon @click="handleHeaderClick" />
    </div>
  </header>
</template>
